import script from "./BusinessEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessEditor.vue?vue&type=script&setup=true&lang=js"

import "./BusinessEditor.vue?vue&type=style&index=0&id=19b5b6f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b5b6f2"]])

export default __exports__